import { useMutation } from '@tanstack/react-query';
import { queryClient, QUERY_KEYS } from '@src/query';
import { ApiError } from '@src/services/api';
import { ApiTypes } from 'common';
import { deleteCrmTemplate } from './api';

export const useMutationDeleteCRMTemplate = () =>
  useMutation<ApiTypes.ResDeleteTemplate, ApiError, string>({
    mutationFn: (templateId: string) => deleteCrmTemplate(templateId),
    onSuccess: async () => {
      const key = QUERY_KEYS.crmTemplates();
      queryClient.invalidateQueries({ queryKey: key });
    },
  });
